module.exports = __webpack_public_path__ + "img/shafie_mouth.b464e4ac.jpg";